export default __webpack_public_path__ + "e0b54939aad0055ebf7f93b1347ddf8a.png";